import React from 'react'
import {
    Box,
    CardHeader as MuiCardHeader,
    IconButton,
    styled,
    Typography,
} from '@mui/material/'
import { ArrowIcon } from 'packages/eid-icons'

const StyledCardHeader = styled(MuiCardHeader)(
    ({ theme, headerColor, colorCode, style }) => ({
        display: 'flex',
        height: '6rem',
        padding: '0 1rem 0 2rem',
        borderBottom: headerColor && '1px solid #efeff1',
        borderLeft: colorCode && `3px solid ${colorCode}`,
        backgroundColor: headerColor ? headerColor : '#ffffff',
        ...style,
        '& .MuiCardHeader-title': {
            '& button': {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
        },
        '& .MuiCardHeader-avatar': {
            width: '1.8rem',
            height: '1.8rem',
        },
        '& .MuiCardHeader-content': {
            width: '100%',
        },
    }),
)

const ColorCode = styled('div')(({ colorCode }) => ({
    width: '0.8rem',
    height: '0.8rem',
    backgroundColor: colorCode,
    borderRadius: '50%',
    marginLeft: '0.8rem',
}))

const CardHeader = (props) => {
    const {
        cardTitle,
        handleExpandClick,
        expanded,
        collapsible,
        headerColor,
        fontColor,
        icon,
        colorCode,
        style,
        isTitleJsx,
    } = props

    return (
        <StyledCardHeader
            avatar={icon}
            title={
                <Box display="flex" justifyContent="space-between">
                    <Box display="flex" alignItems="center" width="100%">
                        {isTitleJsx ? (
                            cardTitle
                        ) : (
                            <Typography
                                sx={{ maxWidth: '90%', color: fontColor }}
                            >
                                {cardTitle}
                            </Typography>
                        )}
                        <ColorCode colorCode={colorCode} />
                    </Box>
                    {collapsible && (
                        <IconButton
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more"
                            disableFocusRipple
                            disableRipple
                            size="large"
                        >
                            <ArrowIcon direction={expanded ? 'up' : 'down'} />
                        </IconButton>
                    )}
                </Box>
            }
            titleTypographyProps={{ variant: 'h2' }}
            headerColor={headerColor}
            colorCode={colorCode}
            style={style}
        />
    )
}

export default CardHeader
